import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowLeftIcon } from '@/assets/icons';
import { Button, Spinner } from '@/components/atoms';
import { TranslationOverviewQuestion } from '@/components/molecules/TranslationOverviewQuestion/TranslationOverviewQuestion';
import { QUESTION_POPUP_TEST_IDS } from '@/constants/data-testids';
import { TranslationQuestion } from '@/types/management/managementCategories';

import { SetQuestionStep } from '../QuestionPopup';

type TranslationManageQuestionProps = {
  submitButtonLabel: string;
  translationOptions: TranslationQuestion[];
  isLoading?: boolean;
  onEditClick: (option: TranslationQuestion) => void;
  setStep: SetQuestionStep;
  onSubmit: () => void;
};

export const TranslationManageQuestion: FC<TranslationManageQuestionProps> = ({
  translationOptions,
  submitButtonLabel,
  isLoading,
  onEditClick,
  setStep,
  onSubmit,
}) => {
  const { t } = useTranslation('components');
  return (
    <div data-testid={QUESTION_POPUP_TEST_IDS.STEP2}>
      <div className="mb-5">
        <p className="text-body-12-semibold text-custom-warm-grey-500 mb-2">
          {t('translationManageQuestion.title')}
        </p>
        <p className="text-body-20-semibold text-custom-warm-grey-800 mb-1.5">
          {t('translationManageQuestion.checkTitle')}
        </p>
        <p className="text-body-14-regular text-custom-warm-grey-500">
          {t('translationManageQuestion.useAITrans')}
        </p>
      </div>
      <TranslationOverviewQuestion
        translationOptions={translationOptions}
        onEditClick={onEditClick}
        className="flex flex-col gap-5 max-h-[576px] mb-6 overflow-y-auto pr-6 pb-1"
      />

      <div className="flex items-center gap-3">
        <Button
          size="lg"
          variant="secondary"
          className="w-full"
          onClick={() => setStep('step1')}
          leftIcon={<ArrowLeftIcon width={20} height={20} className="text-custom-warm-grey-500" />}
        >
          {t('translationManageQuestion.backButton')}
        </Button>
        <Button size="lg" variant="primary" className="relative w-full" onClick={onSubmit}>
          {submitButtonLabel}{' '}
          {isLoading && <Spinner className="absolute top-1/2 -translate-y-1/2 right-6" />}
        </Button>
      </div>
    </div>
  );
};
